import { render, staticRenderFns } from "./CourseBar.vue?vue&type=template&id=a194b16a&scoped=true"
import script from "./CourseBar.vue?vue&type=script&lang=js"
export * from "./CourseBar.vue?vue&type=script&lang=js"
import style0 from "./CourseBar.vue?vue&type=style&index=0&id=a194b16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a194b16a",
  null
  
)

export default component.exports